<template>
    <TableRow :is-selected="isSelected" class="text-gray-700"
        @dblclick="toggleExpandRow"
        @mouseenter="handleRowEnter(2000)"
        @mouseleave="handleRowLeave"
    >
        <td class="border-r border-b border-gray-200 align-top relative" :style="rowActionsOuterCellStyle" ref="rowBoundary">
            <div :style="rowActionsInnerCellStyle" class="py-0.5 h-full">
                <!-- <div class="cursor-pointer h-6 flex justify-start items-center space-x-1 px-3">     
                    <input type="checkbox" id="checkbox" class="accent-dark-secondary cursor-pointer" :checked="isSelected" @change="toggleSelected"/>
                    <div class="cursor-pointer p-[1px] rounded hover:bg-indigo-200" @click="toggleExpandRow">
                        <ChevronUpMiniSVG v-if="expandedRow" fill="black" iconClass="h-3.5 w-3.5" class="" />
                        <ChevronDownMiniSVG v-else fill="black" iconClass="h-3.5 w-3.5" class="" />
                    </div>
                </div> -->
                <div class="flex items-center justify-center h-full">
                    <div class="cursor-pointer p-1.5 rounded-full hover:bg-indigo-200" @click="performRowAction({actionKey: 'openEditForm'})">
                        <ExpandSVG />
                    </div>
                </div>
            </div>
        </td>
        <td class="border-r border-b border-gray-200 align-top">
            <div class="px-3 py-1.5 flex flex-col">
                <div class="flex flex-col ">
                    <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                        <div class="font-semibold text-black">
                            {{ client.client_name }}
                        </div>
                    </div>
                </div>
                <div  id="status-section"  class="w-full">
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Status:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div class="">
                                {{ client.status }}
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="status-section"  class="w-full">
                    <div class="flex w-full justify-between ">
                        <div title="Total time between Client's first engagement and last engagement or today" class="hover:cursor-help whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Client Age:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div >
                                {{ clientAge }}
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="email-alias-section"  class="w-full">
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Email Alias:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
                        <div class="flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div class="break-all">
                                {{ client.email_alias ? client.email_alias : '--' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="fee-structure-section"  class="w-full">
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Account Staff:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <!-- <div class="">
                                {{ client.fee_structure }}
                            </div> -->
                            <div>
                                {{ accountStaff }}
                            </div>
                        </div>
                    </div>
                </div>
                <div  id="location-section-section"  class="w-full">
                    <div class="flex flex-col">
                        <div class="flex w-full justify-between ">
                            <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                                Location:
                            </div>
                            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                            <div class="flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                                <div class="">
                                    {{ fullAddress }}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="flex w-full justify-between ">
                            <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                                TZ:
                            </div>
                            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                            <div class="flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                                <div class="">
                                    {{ client.time_zone ? client.time_zone : '--' }}
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>
            </div>
        </td>

        <td 
            class="border-r border-b border-gray-200 align-top relative bg-inherit"
            @mouseenter="showEngagementActions(actionDelay)"
            @mouseleave="hideEngagementActions"
            :style="engagementOuterCellStyle"
        >
            <div 
                @click="showEngagementActions"
                class="w-full flex flex-col items-start justify-start" 
                :style="engagementInnerCellStyle"
            >
                <div v-if="engagements.length > 0" class="w-full overflow-x-clip">
                    <Transition
                        class="duration-300 ease-out"
                        :enter-from-class="engagementCardEnterFromClass"
                        :leave-to-class="engagementCardLeaveToClass"
                        enter-active-class="bg-gray-200"
                        leave-active-class="bg-gray-200"
                        key="engagement-card"
                    >
                        <EngagementCard
                            class="rounded-md"
                            v-if="displayEngagement"
                            :engagement="displayEngagement"
                            :client="client"
                            :expandedRow="expandedRow"
                        />
                    </Transition>
                </div>
                <div v-else class="tracking-wide">
                    No Engagements
                </div>
            </div>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform -translate-y-full opacity-0"
                leave-to-class="transform -translate-y-full opacity-0"
                key="engagement-actions-menu"
            >
                <div v-if="visibleEngagementActions"
                    ref="engagementActionsMenuBoundary"
                    class="w-[calc(100%+6px)] flex flex-wrap justify-end gap-1.5 shadow-md rounded-b-lg px-2 py-2 absolute -left-[3px] z-10 bg-inherit border-b-[3px] border-x-[3px] border-[#9EA0BD]"
                    :style="engagementActionsMenuStyle"
                >
                    <div v-if="engagements.length > 1" class="flex space-x-1">
                        <button
                            class=" hover:bg-gray-200 h-[26px] 2xl:h-[30px] cursor-pointer text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            @click="getPrevEngagement"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &lt;
                        </button>
                        <div class="flex items-center px-1">
                            {{ displayEngagementNumber }} of {{ engagementCount }}  
                        </div>
                        <button
                            class=" hover:bg-gray-200 h-[26px] 2xl:h-[30px] cursor-pointer text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            @click="getNextEngagement"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &gt;
                        </button>
                    </div>
                    <div v-else-if="engagements.length > 0" class="flex space-x-1">
                        <button
                            class=" h-[26px] 2xl:h-[30px] text-gray-400 bg-gray-200 text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            disabled
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &lt;
                        </button>
                        <div class="flex items-center px-1">
                            {{ displayEngagementNumber }} of {{ engagementCount }}  
                        </div>
                        <button
                            class=" h-[26px] 2xl:h-[30px] text-gray-400 bg-gray-200 text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            disabled
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &gt;
                        </button>
                    </div>
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'openAllEngagements'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-28  bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium px-1 py-1 rounded-md"
                        >
                            All Engagements
                        </button>
                        </div>
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'addEngagement'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-8 h-[26px] 2xl:h-[29px] text-sm 2xl:text-base bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium rounded-md">
                            +
                        </button>
                    </div>
                </div>
            </Transition>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform translate-y-[170%] opacity-0"
                leave-to-class="transform translate-y-[170%] opacity-0"
                key="contact-menu-icon"
            >
                <Grid3x2SVG v-if="!visibleEngagementActions" :fill="menuIconFill" iconClass="h-3 w-3" class="absolute right-3 bottom-1.5" />
            </Transition>
        </td>
        <td 
            class="border-r border-b border-gray-200 align-top relative bg-inherit"
            @mouseenter="showActiveInvoiceActions(actionDelay)"
            @mouseleave="hideActiveInvoiceActions"
            :style="activeInvoiceOuterCellStyle"
        >
            <div 
                @click="showActiveInvoiceActions"
                class="w-full flex flex-col items-start justify-start" 
                :style="activeInvoiceInnerCellStyle"
            >
                <div v-if="activeEngagements.length > 0" class="w-full overflow-x-clip flex flex-col">
                    <EngagementInvoiceCard 
                        v-for="activeEngagement in activeEngagements" :key="activeEngagement.id"
                        :engagement="activeEngagement"
                        :client="client"
                        class="border-b-2 mb-1 last:border-b-0 last:mb-0"
                    />
                </div>
                <div v-else class="tracking-wide">
                    No Active Invoices
                </div>
            </div>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform -translate-y-full opacity-0"
                leave-to-class="transform -translate-y-full opacity-0"
                key="engagement-actions-menu"
            >
                <div v-if="visibleActiveInvoiceActions"
                    ref="activeInvoiceActionsMenuBoundary"
                    class="w-[calc(100%+6px)] flex flex-wrap justify-end gap-1.5 shadow-md rounded-b-lg px-2 py-2 absolute -left-[3px] z-10 bg-inherit border-b-[3px] border-x-[3px] border-[#9EA0BD]"
                    :style="activeInvoiceActionsMenuStyle"
                >
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'openAllInvoices'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-28  bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium px-1 py-1 rounded-md"
                        >
                            All Invoices
                        </button>
                        </div>
                    <!-- <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'addEngagement'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-8 h-[26px] 2xl:h-[29px] text-sm 2xl:text-base bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium rounded-md">
                            +
                        </button>
                    </div> -->
                </div>
            </Transition>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform translate-y-[170%] opacity-0"
                leave-to-class="transform translate-y-[170%] opacity-0"
                key="contact-menu-icon"
            >
                <Grid3x2SVG v-if="!visibleActiveInvoiceActions" :fill="menuIconFill" iconClass="h-3 w-3" class="absolute right-3 bottom-1.5" />
            </Transition>
        </td>
        <td class="border-r border-b border-gray-200 align-top">
            <div style="padding: 28px 12px 6px 12px;" class="px-3 py-1.5 flex flex-col">
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Payment Count:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div title="Total number of retainer invoices paid by client." class="hover:cursor-help ">
                                {{ client.payment_count }}
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Avg. Timing:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div class="">
                                {{ averagePaymentTiming }}
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Payment Standing:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class=" flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div :class="{'bg-red-200' : client.has_overdue_invoices}" class="px-1">
                                {{ paymentStanding }}
                            </div>
                        </div>
                    </div>
            </div>
        </td>
        <td 
            class="border-r border-b border-gray-200 align-top relative bg-inherit"
            @mouseenter="showWorkflowStepActions(actionDelay)"
            @mouseleave="hideWorkflowStepActions"
            :style="workflowStepOuterCellStyle"
        >
            <div 
                @click="showWorkflowStepActions"
                class="w-full flex flex-col items-start justify-start" 
                :style="workflowStepsInnerCellStyle"
            >
                <div id="workflow-steps-section"  class="w-full h-full">
                    <MissingWorkflowStepsCell :client="client" :work-flow-steps="workflowSteps" />
                </div>
            </div>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform -translate-y-full opacity-0"
                leave-to-class="transform -translate-y-full opacity-0"
                key="engagement-actions-menu"
            >
                <div v-if="visibleWorkflowStepActions"
                    ref="workflowStepActionsMenuBoundary"
                    class="w-[calc(100%+6px)] flex flex-wrap justify-end gap-1.5 shadow-md rounded-b-lg px-2 py-2 absolute -left-[3px] z-10 bg-inherit border-b-[3px] border-x-[3px] border-[#9EA0BD]"
                    :style="workflowStepActionsMenuStyle"
                >
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'openAllWorkflowSteps'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-28  bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium px-1 py-1 rounded-md"
                        >
                            All Workflow Steps
                        </button>
                        </div>
                    <!-- <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'addEngagement'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-8 h-[26px] 2xl:h-[29px] text-sm 2xl:text-base bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium rounded-md">
                            +
                        </button>
                    </div> -->
                </div>
            </Transition>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform translate-y-[170%] opacity-0"
                leave-to-class="transform translate-y-[170%] opacity-0"
                key="contact-menu-icon"
            >
                <Grid3x2SVG v-if="!visibleWorkflowStepActions" :fill="menuIconFill" iconClass="h-3 w-3" class="absolute right-3 bottom-1.5" />
            </Transition>
        </td>
        <td 
            class="border-r border-b border-gray-200 align-top relative bg-inherit"
            @mouseenter="showClientPostActions(actionDelay)"
            @mouseleave="hideClientPostActions"
            :style="clientPostOuterCellStyle"
        >
            <div 
                @click="showClientPostActions"
                class="w-full flex flex-col items-start justify-start h-full" 
                :style="clientPostInnerCellStyle"
            >
                <div id="client-posts-section"  class="w-full h-full">
                    <ClientPostsCellNew :client-posts="client.client_posts" />
                </div>
            </div>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform -translate-y-full opacity-0"
                leave-to-class="transform -translate-y-full opacity-0"
                key="engagement-actions-menu"
            >
                <div v-if="visibleClientPostActions"
                    ref="clientPostActionsMenuBoundary"
                    class="w-[calc(100%+6px)] flex flex-wrap justify-end gap-1.5 shadow-md rounded-b-lg px-2 py-2 absolute -left-[3px] z-10 bg-inherit border-b-[3px] border-x-[3px] border-[#9EA0BD]"
                    :style="clientPostActionsMenuStyle"
                >
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'openAllClientPosts'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-28  bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium px-1 py-1 rounded-md"
                        >
                            All Posts
                        </button>
                        </div>
                    <!-- <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'addEngagement'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-8 h-[26px] 2xl:h-[29px] text-sm 2xl:text-base bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium rounded-md">
                            +
                        </button>
                    </div> -->
                </div>
            </Transition>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform translate-y-[170%] opacity-0"
                leave-to-class="transform translate-y-[170%] opacity-0"
                key="contact-menu-icon"
            >
                <Grid3x2SVG v-if="!visibleClientPostActions" :fill="menuIconFill" iconClass="h-3 w-3" class="absolute right-3 bottom-1.5" />
            </Transition>
        </td>
        <td 
            class="border-r border-b border-gray-200 align-top relative bg-inherit"
            @mouseenter="showContactActions(actionDelay)"
            @mouseleave="hideContactActions"
            :style="contactsOuterCellStyle"
        >
            <div 
                @click="showContactActions"
                class="w-full flex flex-col items-start justify-start" 
                :style="contactsInnerCellStyle"
            >
                <div v-if="primaryContacts.length > 0" class="w-full overflow-x-clip">
                    <Transition
                        class="duration-300 ease-out"
                        :enter-from-class="contactCardEnterFromClass"
                        :leave-to-class="contactCardLeaveToClass"
                        enter-active-class="bg-gray-200"
                        leave-active-class="bg-gray-200"
                        key="contact-card"
                    >
                        <ClientContactCard
                            class="rounded-md"
                            v-if="primaryContact"
                            :contact="primaryContact"
                            :expandedRow="expandedRow"
                        />
                    </Transition>
                </div>
                <div v-else class="tracking-wide">
                    No Primary Contacts
                </div>
            </div>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform -translate-y-full opacity-0"
                leave-to-class="transform -translate-y-full opacity-0"
                key="contact-actions-meny"
            >
                <div v-if="visibleContactActions"
                    ref="contactActionsMenuBoundary"
                    class="w-[calc(100%+6px)] flex flex-wrap justify-end gap-1.5 shadow-md rounded-b-lg px-2 py-2 absolute -left-[3px] z-10 bg-inherit border-b-[3px] border-x-[3px] border-[#9EA0BD]"
                    :style="contactActionsMenuStyle"
                >
                    <div v-if="primaryContacts.length > 1" class="flex space-x-1">
                        <button
                            class=" hover:bg-gray-200 h-[26px] 2xl:h-[30px] cursor-pointer text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            @click="getPrevPrimaryContact"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &lt;
                        </button>
                        <div class="flex items-center px-1">
                            {{ primaryContactNumber }} of {{ numPrimaryContacts }}  
                        </div>
                        <button
                            class=" hover:bg-gray-200 h-[26px] 2xl:h-[30px] cursor-pointer text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            @click="getNextPrimaryContact"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &gt;
                        </button>
                    </div>
                    <div v-else-if="primaryContacts.length > 0" class="flex space-x-1">
                        <button
                            class=" h-[26px] 2xl:h-[30px] text-gray-400 bg-gray-200 text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            disabled
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &lt;
                        </button>
                        <div class="flex items-center px-1">
                            {{ primaryContactNumber }} of {{ numPrimaryContacts }}  
                        </div>
                        <button
                            class=" h-[26px] 2xl:h-[30px] text-gray-400 bg-gray-200 text-sm 2xl:text-base rounded-md px-2.5 py-0.5 underline"
                            disabled
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                        >
                            &gt;
                        </button>
                    </div>
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'openAllContacts'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-28  bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium px-1 py-1 rounded-md"
                        >
                            All Contacts
                        </button>
                        </div>
                    <div class="">
                        <button 
                            @click="performRowAction({actionKey: 'addContact'})"
                            @mouseenter="blockExpandRow"
                            @mouseleave="unblockExpandRow"
                            class="w-8 h-[26px] 2xl:h-[29px] text-sm 2xl:text-base bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap tracking-wide font-medium rounded-md">
                            +
                        </button>
                        </div>
                </div>
            </Transition>
            <Transition
                class="duration-300 ease-out"
                enter-from-class="transform translate-y-[170%] opacity-0"
                leave-to-class="transform translate-y-[170%] opacity-0"
                key="contact-menu-icon"
            >
                <Grid3x2SVG v-if="!visibleContactActions" :fill="menuIconFill" iconClass="h-3 w-3" class="absolute right-3 bottom-1.5" />
            </Transition>
        </td>
    </TableRow>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, computed, onMounted } from 'vue';
import ExpandSVG from '../svg-components/ExpandSVG.vue';
import LoadingButton from '../base-components/LoadingButton.vue';
import TableRow from '../base-components/TableRow.vue';
import EngagementCard from '../engagement-components/EngagementCard.vue';
import EngagementInvoiceCard from '../engagement-components/EngagementInvoiceCard.vue';
import MissingWorkflowStepsCell from './table/MissingWorkflowStepsCell.vue';
import ClientPostsCellNew from './table/ClientPostsCellNew.vue';
import ChevronDownMiniSVG from '../svg-components/ChevronDownMiniSVG.vue';
import ChevronUpMiniSVG from '../svg-components/ChevronUpMiniSVG.vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import ClientContactCard from './ClientContactCard.vue';
import Grid3x2SVG from '../svg-components/Grid3x2SVG.vue';

const props = defineProps([
    'client', 
    'selectAll', 
    'expandAll',
    'clearedSelectedResults',
    'workflowSteps'
])

const emit = defineEmits([
    'open-row-details', 
    'select-row', 
    'deselect-row', 
    'update-crm-status',
    'perform-row-action',
])

const isSelected = ref(props.selectAll)
const expandedRow = ref(false)
const rowHover = ref(false)
const canSetRowHover = ref(false)
const canExpandRow = ref(true)
const haltEmit = ref(false)
const isNamePopoverVisible = ref(false)
const xPosition = ref(0)
const yPosition = ref(0)
const nameElement = ref(null)

const crmDetailsEndIndex = ref(2)


const canShowBusinessInfoActions = ref(false)
const visibleBusinessInfoActions = ref(false)

const statusClass = computed(() => {
    if(props.payment.status == 'pending'){
        return 'bg-yellow-200'
    }
    if(props.payment.status == 'paid'){
        return 'bg-green-200'
    }
    if(props.payment.status == 'lost'){
        return 'bg-red-200'
    }
    return ''
})

const canShowCampaignActions = ref(false)
const visibleCampaignActions = ref(false)


const fullAddress = computed(() => {
  return props.client ? `${props.client.address ? props.client.address : '--'} ${props.client.city ? props.client.city : '--'}, ${props.client.state ? props.client.state : '--'}` : '--'
})

const paymentStanding = computed(() => {
    if(props.client.has_overdue_invoices){
        let totalOverdueDays = props.client.total_days_overdue.reduce((prev, curr) => {
            return prev + curr
        }, 0)
        let returnString = `Overdue ${totalOverdueDays} day${totalOverdueDays == 1 ? '' : 's'}`
        if(props.client.total_days_overdue.length > 1){
            returnString += ` (${props.client.total_days_overdue.join(', ')})`
        }
        return returnString
    } else {
        return 'Good'
    }
})

const accountStaff = computed(() => {
    if(props.client.account_staff_members.length > 0){
        return props.client.account_staff_members.map((user) => `${user.first_name} ${user.last_name}`).join(", ")
    } else {
        return '--'
    }
})

const engagements = computed(() => {
    return props.client.engagements
})

const activeEngagements = computed(() => {
    const today = new Date()
    return engagements.value.filter((engagement) => {
        return (!engagement.end_date || new Date(engagement.end_date) > today) && engagement.should_invoice
    })
})

const engagementCount = computed(() => {
    return engagements.value.length
})

const averagePaymentTiming = computed(() => {
    if(props.client.average_payment_timing < 0){
        return `${Math.abs(props.client.average_payment_timing)} days early`
    } else if(props.client.average_payment_timing > 0){
        return `${Math.abs(props.client.average_payment_timing)} days late`
    } else {
        if(props.client.payment_count){
            return '0 days late'
        } else {
            return 'N/A'
        }
    }
})


const displayEngagement = ref(engagements.value.length > 0 ? engagements.value[0] : null)
const displayEngagementNumber = ref(engagements.value.length > 0 ? 1 : null)

watch(engagements, () => {
    displayEngagement.value = engagements.value.length > 0 ? engagements.value[0] : null
})

const canShowCRMActions = ref(false)
const visibleCRMActions = ref(false)

const canShowEngagementActions = ref(false)
const canShowActiveInvoiceActions = ref(false)
const canShowWorkflowStepActions = ref(false)
const canShowClientPostActions = ref(false)
const visibleEngagementActions = ref(false)
const visibleActiveInvoiceActions = ref(false)
const visibleWorkflowStepActions = ref(false)
const visibleClientPostActions = ref(false)

const engagementCardEnterFromClass = ref('transform translate-x-[160%] opacity-0')
const engagementCardLeaveToClass = ref('transform -translate-x-[160%] opacity-0')

const rowBoundary = ref(null)
const businessInfoActionsMenuBoundary = ref(null)
const campaignActionsMenuBoundary = ref(null)
const crmActionsMenuBoundary = ref(null)
const engagementActionsMenuBoundary = ref(null)
const activeInvoiceActionsMenuBoundary = ref(null)
const workflowStepActionsMenuBoundary = ref(null)
const clientPostActionsMenuBoundary = ref(null)
const contactActionsMenuBoundary = ref(null)

const initialRowHeight = ref(null)

onMounted(() => {
    // initialRowHeight.value = Math.round(rowBoundary.value.getBoundingClientRect().bottom - rowBoundary.value.getBoundingClientRect().top).toString()
})

const rowActionsOuterCellStyle = computed(() => {
    return ''
})

const rowActionsInnerCellStyle = computed(() => {
    return ''
})

const companyInfoOuterCellStyle = computed(() => {
    return ''
})

const companyInfoInnerCellStyle = computed(() => {
    return ''
})

const businessInfoOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleBusinessInfoActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const engagementOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleEngagementActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const engagementInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    if(visibleEngagementActions.value) {
        innerCellStyle += 'padding: 25px 9px 3px 9px;'
    } else {
        innerCellStyle += 'padding: 28px 12px 6px 12px;'
    }
    return innerCellStyle
})

const activeInvoiceOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleActiveInvoiceActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const workflowStepsInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    if(visibleWorkflowStepActions.value) {
        innerCellStyle += 'padding: 25px 9px 3px 9px;'
    } else {
        innerCellStyle += 'padding: 28px 12px 6px 12px;'
    }
    return innerCellStyle
})

const workflowStepOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleWorkflowStepActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const clientPostInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    if(visibleClientPostActions.value) {
        innerCellStyle += 'padding: 25px 9px 3px 9px;'
    } else {
        innerCellStyle += 'padding: 28px 12px 6px 12px;'
    }
    return innerCellStyle
})

const clientPostOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleClientPostActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const activeInvoiceInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    if(visibleActiveInvoiceActions.value) {
        innerCellStyle += 'padding: 25px 9px 3px 9px;'
    } else {
        innerCellStyle += 'padding: 28px 12px 6px 12px;'
    }
    return innerCellStyle
})

const contactsOuterCellStyle = computed(() => {
    let outerCellStyle = ''
    if(expandedRow.value) {
        outerCellStyle += 'height: 100%; '
    } else {
        outerCellStyle += `height: ${initialRowHeight.value}px; `
    }
    if(visibleContactActions.value) {
        outerCellStyle += `border-top: 3px solid #9EA0BD; border-right: 3px solid #9EA0BD; border-bottom: none; border-left: 3px solid #9EA0BD; border-top-left-radius: 8px; border-top-right-radius: 8px;`
    }
    return outerCellStyle
})

const contactsInnerCellStyle = computed(() => {
    let innerCellStyle = ''
    if(visibleContactActions.value) {
        innerCellStyle += 'padding: 25px 9px 3px 9px;'
    } else {
        innerCellStyle += 'padding: 28px 12px 6px 12px;'
    }
    return innerCellStyle
})

const engagementActionsMenuStyle = computed(() => {
    if(visibleEngagementActions.value && engagementActionsMenuBoundary.value) {
        let menuHeight = Math.round(engagementActionsMenuBoundary.value.getBoundingClientRect().bottom - engagementActionsMenuBoundary.value.getBoundingClientRect().top-1).toString()
        return `bottom: -${menuHeight}px;`
    }
    return ''
})

const activeInvoiceActionsMenuStyle = computed(() => {
    if(visibleActiveInvoiceActions.value && activeInvoiceActionsMenuBoundary.value) {
        let menuHeight = Math.round(activeInvoiceActionsMenuBoundary.value.getBoundingClientRect().bottom - activeInvoiceActionsMenuBoundary.value.getBoundingClientRect().top-1).toString()
        return `bottom: -${menuHeight}px;`
    }
    return ''
})

const workflowStepActionsMenuStyle = computed(() => {
    if(visibleWorkflowStepActions.value && workflowStepActionsMenuBoundary.value) {
        let menuHeight = Math.round(workflowStepActionsMenuBoundary.value.getBoundingClientRect().bottom - workflowStepActionsMenuBoundary.value.getBoundingClientRect().top-1).toString()
        return `bottom: -${menuHeight}px;`
    }
    return ''
})

const clientPostActionsMenuStyle = computed(() => {
    if(visibleClientPostActions.value && clientPostActionsMenuBoundary.value) {
        let menuHeight = Math.round(clientPostActionsMenuBoundary.value.getBoundingClientRect().bottom - clientPostActionsMenuBoundary.value.getBoundingClientRect().top-1).toString()
        return `bottom: -${menuHeight}px;`
    }
    return ''
})

function showEngagementActions(delay=null) {
    canShowEngagementActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowEngagementActions.value) {
                visibleEngagementActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleEngagementActions.value = true
        rowHover.value = true
    }
}

function showActiveInvoiceActions(delay=null) {
    canShowActiveInvoiceActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowActiveInvoiceActions.value) {
                visibleActiveInvoiceActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleActiveInvoiceActions.value = true
        rowHover.value = true
    }
}

function showWorkflowStepActions(delay=null) {
    canShowWorkflowStepActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowWorkflowStepActions.value) {
                visibleWorkflowStepActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleWorkflowStepActions.value = true
        rowHover.value = true
    }
}

function showClientPostActions(delay=null) {
    canShowClientPostActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowClientPostActions.value) {
                visibleClientPostActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleClientPostActions.value = true
        rowHover.value = true
    }
}

function hideEngagementActions() {
    canShowEngagementActions.value = false
    visibleEngagementActions.value = false
}

function hideActiveInvoiceActions() {
    canShowActiveInvoiceActions.value = false
    visibleActiveInvoiceActions.value = false
}

function hideWorkflowStepActions() {
    canShowWorkflowStepActions.value = false
    visibleWorkflowStepActions.value = false
}

function hideClientPostActions() {
    canShowClientPostActions.value = false
    visibleClientPostActions.value = false
}


function getPrevEngagement() {
    if(engagements.value.length > 1) {
        let index = displayEngagementNumber.value - 1
        if(index > 0) {
            engagementCardEnterFromClass.value = 'transform -translate-x-[160%] opacity-0'
            engagementCardLeaveToClass.value = 'transform translate-x-[160%] opacity-0'
            displayEngagement.value = null
            setTimeout(() => {
                displayEngagement.value = engagements.value[index - 1]
                displayEngagementNumber.value -= 1
            }, 50)

        }
    }
}

function getNextEngagement() {
    if(engagements.value.length > 1) {
        let index = displayEngagementNumber.value - 1
        if(index < engagements.value.length - 1) {
            engagementCardEnterFromClass.value = 'transform translate-x-[200%] opacity-0'
            engagementCardLeaveToClass.value = 'transform -translate-x-[200%] opacity-0'
            displayEngagement.value = null
            setTimeout(() => {
                displayEngagement.value = engagements.value[index + 1]
                displayEngagementNumber.value += 1
            }, 50)

        }
    }
}


const menuIconFill = computed(() => {
    return '#99a1af'
})

function blockExpandRow() {
    canExpandRow.value = false
}

function unblockExpandRow() {
    canExpandRow.value = true
}

function showBusinessInfoActions(delay=null) {
    canShowBusinessInfoActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowBusinessInfoActions.value) {
                visibleBusinessInfoActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleBusinessInfoActions.value = true
        rowHover.value = true
    }

}

function expandRow() {
    expandedRow.value = true
    crmDetailsEndIndex.value = null
}

function collapseRow() {
    expandedRow.value = false
    crmDetailsEndIndex.value = 2
}

function toggleExpandRow() {
    if(canExpandRow.value) {
        if(expandedRow.value) {
            collapseRow()
        } else {
            expandRow()
        }
    }

}

function handleRowEnter(delay) {
    canSetRowHover.value = true
    if(delay) {
        setTimeout(() => {
            if(canSetRowHover.value) {
                rowHover.value = true
            }
        }, delay)
    } else {
        expandRow()
    }
}

function handleRowLeave() {
    canSetRowHover.value = false
    rowHover.value = false
}

function toggleSelected() {
    if(isSelected.value) {
        isSelected.value = false
        emit('deselect-row', props.company)
    } else {
        isSelected.value = true
        emit('select-row', props.company)
    }
}


const actionDelay = computed(() => {
    if(expandedRow.value || rowHover.value) {
        return 150
    } else {
        return 1250
    }
})

const clientAge = computed(() => {
    return props.client.client_age
})

function performRowAction(actionData) {
    actionData.client = props.client
    emit('perform-row-action', actionData)
}
const primaryContacts = computed(() => {
    if(props.client.contacts){
        let primaryContactsList = []
        props.client.contacts.forEach((contact) => {
            if(contact.is_primary_contact){
                primaryContactsList.push(contact)
            }
        })
        return primaryContactsList
    } else {
        return []
    }
})


const numPrimaryContacts = computed(() => {
    return primaryContacts.value.length
})

const primaryContact = ref(primaryContacts.value.length > 0 ? primaryContacts.value[0] : null)
const primaryContactNumber = ref(primaryContacts.value.length > 0 ? 1 : null)
const contactCardEnterFromClass = ref('transform translate-x-[160%] opacity-0')
const contactCardLeaveToClass = ref('transform -translate-x-[160%] opacity-0')

const canShowContactActions = ref(false)
const visibleContactActions = ref(false)


function showContactActions(delay=null) {
    canShowContactActions.value = true
    if(delay) {
        setTimeout(() => {
            if(canShowContactActions.value) {
                visibleContactActions.value = true
                rowHover.value = true
            }
        }, delay)
    } else {
        visibleContactActions.value = true
        rowHover.value = true
    }
}

function hideContactActions() {
    canShowContactActions.value = false
    visibleContactActions.value = false
}

function getPrevPrimaryContact() {
    if(primaryContacts.value.length > 1) {
        let index = primaryContactNumber.value - 1
        if(index > 0) {
            contactCardEnterFromClass.value = 'transform -translate-x-[160%] opacity-0'
            contactCardLeaveToClass.value = 'transform translate-x-[160%] opacity-0'
            primaryContact.value = null
            setTimeout(() => {
                primaryContact.value = primaryContacts.value[index - 1]
                primaryContactNumber.value -= 1
            }, 50)

        }
    }
}

function getNextPrimaryContact() {
    if(primaryContacts.value.length > 1) {
        let index = primaryContactNumber.value - 1
        if(index < primaryContacts.value.length - 1) {
            contactCardEnterFromClass.value = 'transform translate-x-[200%] opacity-0'
            contactCardLeaveToClass.value = 'transform -translate-x-[200%] opacity-0'
            primaryContact.value = null
            setTimeout(() => {
                primaryContact.value = primaryContacts.value[index + 1]
                primaryContactNumber.value += 1
            }, 50)

        }
    }
}

watch(() => primaryContacts.value, () => {primaryContacts.value.length > 0 ? primaryContact.value = primaryContacts.value[0] : primaryContact.value = null}, {deep: true})


const contactActionsMenuStyle = computed(() => {
    if(visibleContactActions.value && contactActionsMenuBoundary.value) {
        let menuHeight = Math.round(contactActionsMenuBoundary.value.getBoundingClientRect().bottom - contactActionsMenuBoundary.value.getBoundingClientRect().top-1).toString()
        return `bottom: -${menuHeight}px;`
    }
    return ''
})

</script>